var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    stroke: "#4E2EA9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_777_96",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    fill: "#441E87",
    stroke: "#441E87"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_777_96)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 29.5L5.5 0.5L6.5 0.5L6.5 29.5L5.5 29.5Z",
    fill: "#4E2EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17C4.89543 17 4 16.1046 4 15C4 13.8954 4.89543 13 6 13C7.10457 13 8 13.8954 8 15C8 16.1046 7.10457 17 6 17Z",
    fill: "#4E2EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.125 11H10.875V19H23.125V11ZM10.875 10C10.3918 10 10 10.4477 10 11V19C10 19.5523 10.3918 20 10.875 20H23.125C23.6082 20 24 19.5523 24 19V11C24 10.4477 23.6082 10 23.125 10H10.875Z",
    fill: "#4E2EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.125 -3H10.875V5H23.125V-3ZM10.875 -4C10.3918 -4 10 -3.55228 10 -3V5C10 5.55229 10.3918 6 10.875 6H23.125C23.6082 6 24 5.55228 24 5V-3C24 -3.55228 23.6082 -4 23.125 -4H10.875Z",
    fill: "#4E2EA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.125 25H10.875V33H23.125V25ZM10.875 24C10.3918 24 10 24.4477 10 25V33C10 33.5523 10.3918 34 10.875 34H23.125C23.6082 34 24 33.5523 24 33V25C24 24.4477 23.6082 24 23.125 24H10.875Z",
    fill: "#4E2EA9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIcon);
export default __webpack_public_path__ + "static/media/timeline_icon.97a121285cc2c10cf9c06ca7ab92fd3e.svg";
export { ForwardRef as ReactComponent };